class SiteElementFocus
    extends QueryElement<HTMLElement>
    implements ISiteFocusable {
    
    private _card: SiteCard;

    constructor(card: SiteCard, element: HTMLElement) {
        super(element, true);

        this.setAttr("if-ISiteFocusable", "true");
        this._card = card;
    }
    makeActive(): boolean {
        let elem = this.get();
        elem?.scrollIntoView();
        
        this.addClass("active");

        return true;
    }
    makeInactive(): void {
        this.removeClass("active");
        
    }
    makePrevActive(force = false) {
        if (!this._card.SiteConfig.settings.includes("NoAutoTab") || force) {
            this._card.makePrevFocusableActive(this);
            return true;
        }
        return false;
    }
    makeNextActive(force = false) {
        if (!this._card.SiteConfig.settings.includes("NoAutoTab") || force) {
            this._card.makeNextFocusableActive(this);
            return true;
        }
        return false;
    }
}